var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChart2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 175.313,
    height: 67,
    viewBox: "0 0 175.313 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21af10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92ff85"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bar_Chart",
    "data-name": "Bar Chart",
    d: "M153.955,146V95.75h13.358V146Zm-15.026,0V112.5h13.357V146ZM123.9,146V124.225h13.358V146Zm-15.026,0V104.125h13.357V146Zm-15.026,0V87.375h13.357V146Zm-15.027,0V104.125H92.179V146Zm-15.026,0V112.5H77.152V146Zm-15.027,0V79H62.125v67Zm-15.026,0V95.75H47.1V146Zm-11.687,0V115.85H32.072V146ZM7.027,146V95.75H20.384V146ZM-8,146V112.5H5.357V146Z",
    transform: "translate(8 -79)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart2);
export default __webpack_public_path__ + "static/media/Bar Chart 2.1c4e0b4eb67d4a694918fa89b1b4da04.svg";
export { ForwardRef as ReactComponent };